<template>
  <div class="order-list-wrap">
    <template v-if="orderList.length">
      <table class="head">
        <tbody>
          <tr>
            <td>手机型号</td>
            <td>回收方式</td>
            <td>下单时间</td>
            <td>订单状态</td>
            <td>订单估价</td>
            <td>订单详情</td>
          </tr>
        </tbody>
      </table>
        <div class="order-list">
          <table class="order-item" v-for="(item, index) in orderList" :key="index">
            <tbody>
              <tr class="table-head">
                <td colspan="7" v-text="item.orderNum"></td>
              </tr>
              <tr class="table-row">
                <td class="percent20" colspan="2">
                  <img class="product-logo" :src="item.pic">
                  <p class="product-name" v-text="item.orderNum"></p>
                </td>
                <td class="percent16" v-text="item.recycleTypeName"></td>
                <td class="percent16" v-text="item.orderTime"></td>
                <td class="percent16" v-text="item.orderStatusName"></td>
                <td class="percent16">
                  <span>￥{{ item.totalPrice / 100 }}</span>
                </td>
                <td class="percent16">
                  <div class="order-action" @click="onToDetailsClick(item)">查看详情</div>
                  <div class="order-action" @click="handleCancle(item)" v-if="item.canCancel==1">取消订单</div>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :total="+pageInfo.total"
            :pageSize="+pageInfo.pageSize"
            :pageIndex="pageInfo.pageIndex"
            @current-change="onPageIndexChanged"
            ></Pagination>
        </div>
    </template>
    <template v-else>
      <div class="no-order">您还未下过订单!</div>
    </template>
    <OrderDetails v-if="currrentOrderNum" :orderNum="currrentOrderNum" @on-close="closeOrderPopup"></OrderDetails>
    <Backdrop :value="!!currrentOrderNum" :zIndex="backdropZindex" @click="closeOrderPopup"></Backdrop>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import orderStore from '@/core/order-list/store';
import Pagination from '@/components/pagination';
import Backdrop from '@/components/backdrop';
import OrderDetails from '../orderDetails/index';
import { MessageBox } from 'element-ui';
import { newCancelOrder } from '@/apis/base';

export default {
  components: {
    Backdrop,
    Pagination,
    OrderDetails
  },
  registerModule (store, preserveState) {
    store.registerModule('order', orderStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('order');
  },
  computed: {
    ...mapState({
      pageInfo: state => state.order.pageInfo,
      orderList: state => state.order.orderList
    })
  },
  data () {
    return {
      orderInfo: null,
      currrentOrderNum: '',
      backdropZindex: 999
    };
  },
  methods: {
    onPageIndexChanged (pageIndex) {
      this.$store.dispatch('order/getOrder', { pageIndex, pageSize: this.pageInfo.pageSize });
    },
    onToDetailsClick (order) {
      this.currrentOrderNum = order.orderNum;
    },
    closeOrderPopup () {
      this.currrentOrderNum = '';
    },
    handleCancle (order) {
      MessageBox.confirm('', {
        message: '真的要取消订单吗？',
        title: '提示',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(action => {
        if (action === 'confirm') {
          this.cancleOrder(order.orderNum);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    async cancleOrder (orderNum) {
      const orderList = this.orderList;
      const ret = await newCancelOrder({
        orderNum,
        reason: '用户取消'
      });
      if (ret._errCode === '0') {
        orderList.forEach((item) => {
          if (item.orderNum === orderNum) {
            item.canCancel = '0';
            item.orderStatusName = '已取消';
          }
        });
        this.$store.commit('setOrderList', [].concat(orderList));
      }
    }
  },
  mounted () {
    this.$store.dispatch('order/getOrder', {pageIndex: 1, pageSize: 3});
  }
};
</script>

<style scoped>
.order-list-wrap {
  /deep/ .pager-list {
    padding: 20px 0;
    text-align: right;
  }
  /deep/ .pager-item {
    margin: 0;
    a {
      display: inline-block;
      height: 30px;
      padding: 0 6px;
      min-width: 40px;
      margin-right: -1px;
      line-height: 30px;
      color: #666;
      text-align: center;
      border: 1px #eee solid;
      &:hover {
        z-index: 2;
        position: relative;
        color: #3b9bff;
        border-color: #3b9bff;
      }
    }
    &.is-active a {
      z-index: 2;
      position: relative;
      color: #3b9bff;
      border-color: #3b9bff;
    }
  }
}

.head {
  overflow: hidden;
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
  background-color: #F4F4F4;
  td {
    padding: 0;
  }
}

.table-head td {
  height: 16px;
  padding: 10px;
  font-size: 12px;
  color: #999;
  line-height: 24px;
  text-align: left;
  background-color: #f4f4f4;
}

.table-row td {
  height: 150px;
  color: #707070;
  font-size: 14px;
  border: 1px #eee solid;
}

.product-logo {
  width: 38px;
}

.order-item {
  width: 100%;
  margin-top: 10px;
  text-align: center;
}

.product-name {
  margin-top: 10px;
}

.percent {
  &20 {
    width: 20%;
  }
  &16 {
    width: 16%;
  }
}
.order-action {
  line-height: 24px;
  color: #ff5f43;
  cursor: pointer;
}
.no-order {
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/orderList/index.vue